import useFetch from '@hooks/useFetch';
import { SheldonLibraryResponse } from '@api/fetchers/prime/types';

export const getKey = (subCategoryUID?: string) =>
  subCategoryUID
    ? `sheldon/v1/library/home?sub_category_uid=${subCategoryUID}`
    : null;

const usePrimeLibrary = (subCategoryUID?: string) => {
  const key = getKey(subCategoryUID);

  const { data, isLoading, isError, mutate } = useFetch(key, {});

  return {
    data,
    isLoading,
    isError,
    mutate
  };
};

export default usePrimeLibrary;
